import { GlFilteredSearchSuggestion, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { s__ } from '~/locale';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import searchProjectTopics from '~/graphql_shared/queries/project_topics_search.query.graphql';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'TopicToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion,
        GlIcon
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            topics: [],
            loading: false
        };
    },
    methods: {
        async fetchTopics (search) {
            this.loading = true;
            try {
                const { data } = await this.$apollo.query({
                    query: searchProjectTopics,
                    variables: {
                        search
                    }
                });
                this.topics = (data?.topics?.nodes || []).map((topic)=>({
                        value: topic.name,
                        text: topic.title
                    }));
            } catch  {
                createAlert({
                    message: s__('CiCatalog|There was an error fetching topics.')
                });
            } finally{
                this.loading = false;
            }
        },
        getActiveTokenValue (suggestions, data) {
            return suggestions.find((s)=>s.value === data);
        }
    }
};
